import {Component} from "preact";
import ChatIcon from 'mdi-preact/ChatIcon';
import SectionComponent from "../../../../../layout/section-component";
import ToolbarButton from "../../../../../common/toolbar-button";
import {OutsideClickWrapper} from "../../../../../layout/outside-click-wrapper";
import DropDownMenu from "../../../../../common/dropdown";
import ChatMain from "../chat-main";
import ChatService from "../../../../../../services/ChatService";
import ModuleInfoProvider from "../../../../../../services/ModuleInfoProvider";
import JWTClient from "../../../../../../services/JWTClient";
import SimpleBadge from "../../../../../common/simple-badge";
import {translate} from "../../../../../../services/TranslateService";

export default class ChatButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            error: false,
            count: 0,
            open: false
        }
    }


    static defaultProps = {
        open: false
    };

    componentDidMount() {
        ChatService.start();
        ChatService.observable.subscribe(this.getUnreadChatsCount, true);
    }

    componentWillUnmount() {
        ChatService.stop();
        ChatService.observable.unsubscribe(this.getUnreadChatsCount, true);
    }

    render(props, state, context) {
        const purchased = ModuleInfoProvider.getModule('chat').purchased;
        if (!purchased) return null;

        const badge = () => this.state.count ? (<SimpleBadge>{this.state.count}</SimpleBadge>) : null;
        const buttonStyles = this.state.open ? {background: '#0079B8'} : {};

        return (
            <OutsideClickWrapper watch={this.state.open} onOutsideClick={this.toggleDropdown}>
                <SectionComponent>

                    <ToolbarButton onClick={this.toggleDropdown} title={translate('chat.title')} style={buttonStyles}>
                        {badge()}
                        <ChatIcon/>
                    </ToolbarButton>

                    <DropDownMenu open={this.state.open} closeFunction={this.toggleDropdown}>
                        <ChatMain/>
                    </DropDownMenu>

                </SectionComponent>
            </OutsideClickWrapper>
        );
    }

    toggleDropdown = () => {
        this.setState({open: !this.state.open});
    };

    getUnreadChatsCount = () => {
        this.setState({loading: true, error: false});
        const url = ModuleInfoProvider.getModuleWebServiceUrl('chat') + '/message-counter';
        JWTClient.fetch(url)
            .then(res => {
                const count = parseInt(res.data.unread);
                this.setState({loading: false, error: false, count: count});
                ChatService.badge(count);
            })
            .catch(() => {
                this.setState({loading: false, error: true, count: 0})
                ChatService.badge(0);
            })
        ;
    }
}



// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/chat/chat-button/index.js